import Home from "../Pages/Home/Home";
import { routes } from "../Constants/Routes";
import Services from "../Pages/Services/Services";
import Gallery from "../Pages/Gallery/Gallery";
import Getorder from "../Pages/GetOrder/Getorder";
import NotFound from "../Pages/NotFound/NotFound";
export const RoutersConfig = [
  { path: routes.Home, Component: Home },
  { path: routes.Service, Component: Services },
  { path: routes.Gallery, Component: Gallery },
  { path: routes.GetOrder, Component: Getorder },
  { path: routes.NotFound, Component: NotFound },
];
